// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "shapeme-4606b.firebaseapp.com",
  "projectId": "shapeme-4606b",
  "storageBucket": "shapeme-4606b.appspot.com",
  "messagingSenderId": "274692526916",
  "appId": "1:274692526916:web:7381f01cb8ce87b18e7d11",
  "measurementId": "G-W4MRPP2ZYY",
  "apiKey": "AIzaSyBFRPE4DZdwe_j5K6pTPYcXhquNsD1mqhc"
};
